<template>
  <v-card flat>
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col
        v-if="!hideLevel"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDBlackListLevelFilter
          :remote-list="remoteList"
          :selected-option-value="filteredOfficeList"
          @onBlackListLevelStatusSelectorFilterChange="onBlackListLevelStatusSelectorFilterChange"
        />
      </v-col>
      <v-col
        v-if="!hideOrganization && isOrganizationLevel"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDOrganizationSelectorFilter
          :remote-list="remoteList"
          :selected-option-value="filteredOfficeList"
          @onOrganizationListSelectorFilterChange="onOrganizationListSelectorFilterChange"
        />
      </v-col>
      <v-col
        v-if="!hideOffice"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDOfficeSelectorFilter
          :remote-list="[]"
          :label="'Поиск объектов'"
          select-active
          :remote-selected-list-list="''"
          @onOfficeSelectorFilterChange="onOfficeSelectorFilterChange"
        />
      </v-col>
      <v-col
        v-if="!hideUser"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDLaborerListFilterComponent
          :remote-list="getSelectedUser"
          :remote-selected-option="''"
          boarded
          @onLaborerSelectorFilterChange="onLaborerSelectorFilterChange"
        />
      </v-col>
      <!--      <v-col cols="12"-->
      <!--        v-if="showDate"-->
      <!--        class="px-3"-->
      <!--        :sm="6"-->
      <!--        :md="4"-->
      <!--      >-->
      <!--        <WDatePicker-->
      <!--          :date.sync="blackListFilterSet.expiredAt"-->
      <!--          :label="'Дата разблокировки'"-->
      <!--          :min="getNow"-->
      <!--          :clear-event="eventNames.BLACK_LIST_DATE_END_FILTER_RESET"-->
      <!--          @update:date="setEndDate"-->
      <!--        />-->
      <!--      </v-col>-->
    </v-row>
  </v-card>
</template>

<script>

import WBDOrganizationSelectorFilter from '@/components/common/filter/organization-selector-filter'
import WBDOfficeSelectorFilter from '@/components/common/filter/office-selector-filter'
import WBDLaborerListFilterComponent from '@/components/common/filter/laborer-filter'
import WBDBlackListLevelFilter, {
  BLACK_LIST_LEVEL_ORGANIZATION,
  BLACK_LIST_LEVEL_OFFICE,
  BLACK_LIST_LEVEL_VACANCY,
  BLACK_LIST_LEVEL_SYSTEM,
} from '@/components/common/filter/black-list-level'
// import WDatePicker from '@/components/common/date-picker/index.vue'

export default {
  name: 'WBDBlackListFilter',
  components: {
    // WDatePicker,
    WBDOrganizationSelectorFilter,
    WBDOfficeSelectorFilter,
    WBDLaborerListFilterComponent,
    WBDBlackListLevelFilter,
  },
  props: {
    hideOffice: {
      type: Boolean,
      default: false
    },
    hideOrganization: {
      type: Boolean,
      default: false
    },
    hideUser: {
      type: Boolean,
      default: false
    },
    hideLevel: {
      type: Boolean,
      default: false
    },
    blackListFilterSet: {
      type: Object,
      default: () => ({
        level: null,
        office: null,
        organization: null,
        vacancy: null,
        user: null,
        expireAt: null,
        editMode: null,
      })
    }
  },
  data: () => ({
    searchQuery: '',
    filteredOfficeList: '',
    remoteList: [],
    loading: true,
  }),
  computed: {
    getSelectedUser () {
      return this.blackListFilterSet.user ? [
        {
          id: this.blackListFilterSet.user.id,
          fullName: this.blackListFilterSet.user.fullName
        }
      ] : null
    },
    isOrganizationLevel () {
      return this.blackListFilterSet.level === BLACK_LIST_LEVEL_ORGANIZATION
    },
    showDate () {
      return this.hasRoot && !!this.blackListFilterSet.user
    },
    isEditMode () {
      return !!this.blackListFilterSet.editMode
    },
    hasRoot () {
      return !!this.blackListFilterSet.organization ||
          !!this.blackListFilterSet.office ||
          !!this.blackListFilterSet.vacancy || this.isSystemLevel
    },
    isOfficeLevel () {
      return this.blackListFilterSet.level === BLACK_LIST_LEVEL_OFFICE
    },
    isVacancyLevel () {
      return this.blackListFilterSet.level === BLACK_LIST_LEVEL_VACANCY
    },
    isSystemLevel () {
      return this.blackListFilterSet.level === BLACK_LIST_LEVEL_SYSTEM
    },
    getNow () {
      const minDate = this.$moment().add(1, 'days')
      return minDate.format('YYYY-MM-DD')
    }
  },
  watch: {
    blackListFilterSet: {
      handler (val) {
        for (const [key, value] of Object.entries(val)) {
          if (this.blackListFilterSet[key] !== value) {
            this.blackListFilterSet[key] = value
          }
        }
      },
      deep: true,
    },
  },
  created () {
    this.eventsBus.$on(this.eventNames.BLACK_LIST_FILTER_RESET, () => {
      this.resetAll()
      this.resetAll()
    })
  },
  methods: {
    setEndDate () {},
    onOrganizationListSelectorFilterChange (data, org) {
      this.blackListFilterSet.organization = org
    },
    onOfficeSelectorFilterChange (data, office) {
      this.blackListFilterSet.office = office
    },
    onLaborerSelectorFilterChange (id, laborer) {
      this.blackListFilterSet.user = laborer
    },
    onBlackListLevelStatusSelectorFilterChange (data) {
      this.blackListFilterSet.level = data
    },
    resetAll () {
      this.eventsBus.$emit(this.eventNames.ORG_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.LABORER_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.OFFICE_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.BLACK_LIST_DATE_END_FILTER_RESET)
    },
  }
}
</script>
<style lang="scss" scoped>
.office-item {
  cursor: pointer;
}
</style>
